export default "__VITE_ASSET__BncLLM3A__"